import * as React from 'react';
import { ContactForm } from './ContactForm';

export function HelpContent() {
    return (
        <div className="w-full">
            <ContactForm />
        </div>
    );
}
